module.exports = "/images/check-icon.svg";